'use strict';

var d3 = require('d3');
var Belts = function Belts(tooltip, d3Helper, momentService) {
  /**
   * @param startBeltxPropertyName - a property name used to find start of belt at X axis
   * @param endBeltxPropertyName - a property name used to find end of belt at X axis
   * @param yPropertyName - a property name used to find Y value
   * @param arrayPropertyName - an optional parameter indicating that the element provides an array of items to draw
   * @returns {Function}
   * @constructor
   */
  return function (startBeltxPropertyName, endBeltxPropertyName, yPropertyName, arrayPropertyName, tooltipContentProvider) {
    var params, scales;
    var beltHeight = 30;
    var tooltipInitialized, tip;
    var belts = function belts(container) {
      var unitWidth = scales.xScale.rangeBand();
      var tooltipAdded = tooltipContentProvider !== undefined;
      var domain = scales.yScale.domain();
      var yMin = scales.yScale(domain[domain.length - 1]);
      var yMax = scales.yScale(domain[0]);
      if (tooltipAdded && !tooltipInitialized) {
        tip = tooltip(tooltipContentProvider, tooltipContentProvider.cssClass);
      }
      function isVisible(value) {
        return yMin <= value && value <= yMax;
      }
      var mouseOverHandler = function mouseOverHandler(d) {
        tip.show(d, this);
        tip.offset([-17, 5]);
        d3Helper.adjustTooltipTopPosition();
      };
      var mouseOutHandler = function mouseOutHandler() {
        tip.hideAndAdjustPosition();
      };
      function bindEvents(selection) {
        if (tooltipAdded) {
          selection.on('mouseout', mouseOutHandler);
          selection.on('mouseover', mouseOverHandler);
        }
      }
      var group = container.select('.groups').selectAll('.stack.visible');
      group.each(function (d) {
        function calculateBeltRange(start, end) {
          //1000 * 60 * 60 * 24
          var oneDay = 86400000;
          var xWidth = end - start;
          if (momentService.isMoment(start) && momentService.isMoment(end)) {
            xWidth = Math.floor(xWidth / oneDay) + 1;
          }
          if (xWidth < 0) {
            xWidth = 0;
          }
          return xWidth;
        }
        var start = d[startBeltxPropertyName];
        var end = d[endBeltxPropertyName];
        var beltRange = calculateBeltRange(start, end);
        var clazzToColorMap = d.clazzToColorMap;
        var clazzTextToColorMap = d.clazzTextToColorMap;

        //there was a problem with caching data by d3. So, i decided to remove all data before adding new
        d3.select(this).selectAll('g.belt-group').data([]).exit().remove();
        var dataGroup = d3.select(this).selectAll('g.belt-group').data(arrayPropertyName ? d[arrayPropertyName] : [d]);
        var beltsGroup = dataGroup.enter().append('g').attr({
          "class": 'belt-group'
        }).call(bindEvents);
        beltsGroup.append('rect').attr({
          'height': beltHeight,
          'data-belt-label': function dataBeltLabel(d) {
            return d.beltLabel;
          },
          'class': function _class(d) {
            var className = ['belt'];
            if (typeof d.className !== 'undefined') {
              className.push(d.className);
            }
            return className.join(' ');
          },
          'start': start.toISOString(),
          'end': end.toISOString(),
          'y': function y(d) {
            var value = scales.yScale(d[yPropertyName]);
            return isVisible(value) ? value : -1000;
          },
          'width': beltRange * unitWidth
        }).style({
          'fill': function fill(d) {
            return clazzToColorMap[d.className];
          }
        });
        beltsGroup.append('text').attr({
          'y': function y(d) {
            var value = scales.yScale(d[yPropertyName]) + 13;
            return isVisible(value) ? value : -1000;
          },
          'x': 5
        }).text(function (d) {
          return d.fbc;
        }).style({
          'fill': function fill(d) {
            return clazzTextToColorMap[d.className];
          }
        });
      });
      if (!tooltipInitialized && tooltipAdded) {
        container.call(tip);
        tooltipInitialized = true;
      }
    };
    belts.params = function (value) {
      params = value;
      beltHeight = params.height * params.beltPartHeight || beltHeight;
      return belts;
    };
    belts.scales = function (value) {
      scales = value;
      return belts;
    };
    return belts;
  };
};
Belts.$inject = ['ChartElementsTooltip', 'd3Helper', 'MomentService'];
module.exports = Belts;